/**
 * 商品详情右侧骨架屏组件
 */
export default function ItemRightSkeleton() {
  return (
    <div className="animate-pulse">
      {/* 梯度价格模块骨架 */}
      <div>
        <div className="flex justify-between">
          <div className="h-4 bg-gray-200 rounded w-20"></div>
          <div className="h-4 bg-gray-200 rounded w-36"></div>
        </div>
        <div className="mt-2 h-[150px] bg-gray-200 rounded"></div>
      </div>

      {/* 优惠活动模块骨架 */}
      <div className="mt-5">
        <div className="h-4 bg-gray-200 rounded w-20"></div>
        <div className="mt-2 h-4 bg-gray-200 rounded"></div>
      </div>

      {/* 库存总量模块骨架 */}
      <div className="mt-5">
        <div className="h-4 bg-gray-200 rounded w-20"></div>
        <div className="h-[66px] bg-gray-200 rounded w-full mt-2"></div>
      </div>

      {/* 购买数量模块骨架 */}
      <div className="mt-5">
        <div className="h-4 bg-gray-200 rounded w-20"></div>
        <div className="h-12 bg-gray-200 rounded mt-2"></div>
        {/* 优惠信息 */}
        <div className="flex justify-between mt-2">
          <div className="h-4 bg-gray-200 rounded w-28"></div>
          <div className="h-4 bg-gray-200 rounded w-28"></div>
        </div>
      </div>

      {/* 价格和按钮模块骨架 */}
      <div className="mt-5 mb-8">
        {/* 总价 */}
        <div className="h-6 bg-gray-200 rounded w-48 mt-2"></div>
        {/* 按钮 */}
        <div className="h-12 bg-gray-200 rounded-full mt-2"></div>
        {/* 成交信息 */}
        <div className="h-4 bg-gray-200 rounded w-36 mt-2"></div>
      </div>
    </div>
  );
}
